import { useState } from "react";
import { Fragment } from "react/jsx-runtime";
import { EmailLogModel } from "../../apis/ApisEmailLog";

export type EmailCardRowProps = {
    log: EmailLogModel,
    showMailto: boolean
}


export function EmailCardRow(props: EmailCardRowProps) {
    let date = new Date(props.log.DateAndTime);
    let dateID = `${date.getFullYear()}_${date.getMonth()}_${date.getDay()}_${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}_${date.getMilliseconds()}`;

    const [openState, setOpenState] = useState<boolean>(false);

    let fromText = props.log.FromAddress.length > 20 ? props.log.FromAddress : props.log.FromAddress.substring(0, 20);

    if ((props.log.Sender ?? "").length > 0)
        fromText = `${fromText} on behalf of ${props.log.Sender.length > 20 ? props.log.Sender : props.log.Sender.substring(0, 20)}`;

    return <Fragment key={`${props.log.FromAddress}_${props.log.Subject}_${dateID}`}>
        <div className={`${openState ? "bottom-grey-border-light" : ""}`}>
            <div className="d-flex flex-column">
                {row("fa-user", "From", fromText)}
                {row("fa-pen-to-square", "Subject", props.log.Subject)}
                {row("fa-calendar-days", "Date", new Date(props.log.DateAndTime).toDateString())}
            </div>
            <div className="py-1 d-flex justify-content-center mt-2 mb-2">
                {props.showMailto && (props.log.SenderProxyAddress ?? "").length > 0 && <a className="btn btn-secondary btn-wider me-3 " href={`mailto:${props.log.SenderProxyAddress}?subject=${props.log.Subject.startsWith("Re:") ? props.log.Subject : ("Re:" + props.log.Subject)}`}>Reply</a>}
                <button
                    aria-controls={`bdyCollapse_${dateID}`}
                    data-bs-target={`#bdyCollapse_${dateID}`}
                    aria-expanded={`${openState ? "true" : "false"}`}
                    onClick={e => { setOpenState(!openState) }}
                    data-bs-toggle="collapse"
                    className={`btn btn-outline-soft btn-wider align-content-center`}>Expand <i className={`fa-solid ${(openState ? "fa-chevron-up" : "fa-chevron-down")} me-1`}></i></button>
            </div>
            <div className={`collapse show-new-line pt-0  mb-2 top-secondary-border`} id={`bdyCollapse_${dateID}`}>

                <div className="bg-lightgrey p-3 email-expanded-body" dangerouslySetInnerHTML={{ __html: props.log.Body }}></div>
            </div>
        </div>
    </Fragment>
}

const row = (iconClass: string, title: string, details: string) => {
    return (<div className="py-1 d-flex"><div className="w-50 text-alt-or-contrast"><i className={`fa-solid ${iconClass} me-1`}></i><b>{title}:</b> </div><div className="w-50">{details}</div></div>);
}